import { lazy } from 'react';

const RepairRoutes = [
  // Companies
  {
    path: 'repair/companies',
    component: lazy(() => import('views/repair/companies')),
  },
  {
    path: 'repair/companies/add',
    component: lazy(() => import('views/repair/companies/company-add')),
  },
  {
    path: 'repair/companies/:id',
    component: lazy(() => import('views/repair/companies/company-edit')),
  },
  // Device Models
  {
    path: 'repair/device-models',
    component: lazy(() => import('views/repair/device-models')),
  },
  {
    path: 'repair/device-models/add',
    component: lazy(() => import('views/repair/device-models/device-model-add')),
  },
  {
    path: 'repair/device-models/:id',
    component: lazy(() => import('views/repair/device-models/device-model-edit')),
  },
  // Services
  {
    path: 'repair/services',
    component: lazy(() => import('views/repair/services')),
  },
  {
    path: 'repair/services/add',
    component: lazy(() => import('views/repair/services/service-add')),
  },
  {
    path: 'repair/services/:id',
    component: lazy(() => import('views/repair/services/service-edit')),
  },
  // Featured Services
  {
    path: 'repair/featured-services',
    component: lazy(() => import('views/repair/featured-services')),
  },
  // Banners
  {
    path: 'repair/banners',
    component: lazy(() => import('views/repair/banners')),
  },
  {
    path: 'repair/banners/add',
    component: lazy(() => import('views/repair/banners/banner-add')),
  },
  {
    path: 'repair/banners/:id',
    component: lazy(() => import('views/repair/banners/banner-edit')),
  },
  // Schedule Settings
  {
    path: 'repair/schedule-settings',
    component: lazy(() => import('views/repair/schedule-settings')),
  },
  // Bookings
  {
    path: 'repair/bookings',
    component: lazy(() => import('views/repair/bookings')),
  },
  {
    path: 'repair/bookings/create',
    component: lazy(() => import('views/repair/bookings/booking-add')),
  },
  {
    path: 'repair/bookings/:id',
    component: lazy(() => import('views/repair/bookings/booking-details')),
  },
];

export default RepairRoutes;
